// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desc[data-v-5a7dc173]{margin-left:120px;margin-top:-10px;margin-bottom:10px;color:var(--el-text-color-secondary)}", ""]);
// Exports
module.exports = exports;
